import { Expand, Forward } from "components/common/Icons";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import DividerLine from "components/common/divider/line";

export const ToggleComponent = (contents: {
  subDescription: string;
  Question: React.ReactNode;
  centerContent: React.ReactNode;
  toggleOpenWithChildContents: React.FC;
  index: number;
  toggleStyle?: string;
}) => {
  /**
   * subDescription
   * Question
   * centerContent
   * toggleState
   * toggleOpenWithChildContents
   */
  const [toggleState, setToggleState] = useState(false);
  const [descTooltip, setDescTooltip] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const DetailContents: any = contents.toggleOpenWithChildContents;

  // 외부 클릭 감지
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setDescTooltip(false); // 외부 클릭시 툴팁 숨기기
      }
    };

    // 이벤트 리스너 등록
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // 컴포넌트 언마운트시 이벤트 리스너 해제
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // toggleState가 true가 되었을 때 2초 후 자동으로 비활성화
  useEffect(() => {
    if (descTooltip) {
      const timer = setTimeout(() => {
        setDescTooltip(false); // 2초 후 비활성화
      }, 4000);

      // 컴포넌트 언마운트 또는 toggleState가 변경되면 타이머 해제
      return () => clearTimeout(timer);
    }
  }, [descTooltip]);

  return (
    <div
      className={`detail-toggle ${toggleState ? "toggle-open" : ""} ${
        contents.toggleStyle && toggleState ? contents.toggleStyle : ""
      } items-center w-full`}
    >
      <div
        className={`each-item cursor-pointer flex items-center gap-3 w-full py-2 px-5`}
        data-testid={`each-item`}
        onClick={() => setToggleState(!toggleState)}
      >
        <div className="flex flex-col grow">
          <span className={`${TYPO.TYPO7_RG} text-gray50`}>
            {contents.subDescription}
          </span>
          {contents.Question}
        </div>
        <div>{contents.centerContent}</div>
        {toggleState ? (
          <Expand fill="gray30" height={16} width={16} />
        ) : (
          <Forward fill="gray30" height={16} width={16} />
        )}
      </div>
      <div
        className={`detail-content w-full `}
        data-testid={`detail-content-${contents.index}`}
      >
        {/* {contents.toggleOpenWithChildContents} */}
        <DetailContents
          setDescTooltip={setDescTooltip}
          descTooltip={descTooltip}
          tooltipRef={tooltipRef}
        />
      </div>
    </div>
  );
};

export const FinInfoComponent = (contents: {
  subDescription: string;
  Question: React.ReactNode;
  centerContent: React.ReactNode;
  toggleOpenWithChildContents: React.FC;
  index: number;
  toggleStyle?: string;
}) => {
  /**
   * subDescription
   * Question
   * centerContent
   * toggleState
   * toggleOpenWithChildContents
   */
  const [toggleState, setToggleState] = useState(false);
  const [descTooltip, setDescTooltip] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const DetailContents: any = contents.toggleOpenWithChildContents;

  // 외부 클릭 감지
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setDescTooltip(false); // 외부 클릭시 툴팁 숨기기
      }
    };

    // 이벤트 리스너 등록
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // 컴포넌트 언마운트시 이벤트 리스너 해제
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // toggleState가 true가 되었을 때 2초 후 자동으로 비활성화
  useEffect(() => {
    if (descTooltip) {
      const timer = setTimeout(() => {
        setDescTooltip(false); // 2초 후 비활성화
      }, 4000);

      // 컴포넌트 언마운트 또는 toggleState가 변경되면 타이머 해제
      return () => clearTimeout(timer);
    }
  }, [descTooltip]);

  return (
    <div className={`items-center w-full bg-white`}>
      <div
        className={`detail-contentS w-full `}
        data-testid={`detail-content-${contents.index}`}
      >
        {/* {contents.toggleOpenWithChildContents} */}
        <DetailContents
          setDescTooltip={setDescTooltip}
          descTooltip={descTooltip}
          tooltipRef={tooltipRef}
        />
      </div>
      {contents.index !== 3 && <DividerLine size="lg" />}
    </div>
  );
};

function DiagnosisMoreSection({
  toggleContents,
}: {
  toggleContents: React.ReactNode[];
}) {
  const [currentActive, setCurrentActive] = useState(0);
  const { t } = useTranslation("detail");
  return (
    <div className="px-5 py-2">
      <div className="bg-white rounded-[20px] flex flex-col">
        <div className={`${TYPO.TYPO7_SB} text-gray60 px-5 pt-5`}>
          {t("details")}
        </div>
        <div className="py-2 flex flex-col gap-2">
          {toggleContents?.map((content, index) => (
            <div key={index}>{content}</div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DiagnosisMoreSection;
